import React, { memo } from 'react'
import { Skeleton } from 'antd'

import styles from '../ProjectCapacityDashboard.module.css'

const CapacitySkeleton = memo(() => (
    <div className={styles.skeletonWrap}>
        <div className={styles.summaryRow}>
            {Array.from({ length: 5 }).map((_, index) => (
                <div key={index} className={styles.summaryCard}>
                    <Skeleton.Input active size="small" style={{ width: 120 }} />
                    <Skeleton.Input
                        active
                        size="large"
                        style={{ width: 80, marginTop: 8 }}
                    />
                </div>
            ))}
        </div>

        <div className={styles.timelineSkeleton}>
            <Skeleton.Input active style={{ width: 180, marginBottom: 12 }} />
            <Skeleton.Node active style={{ width: '100%', height: 120 }} />
            <Skeleton.Node active style={{ width: '100%', height: 80, marginTop: 8 }} />
        </div>

        <div className={styles.tableSkeleton}>
            <Skeleton active paragraph={{ rows: 5 }} />
        </div>
    </div>
))

CapacitySkeleton.displayName = 'CapacitySkeleton'

export default CapacitySkeleton
